import { useEffect, useState } from "react";

const SLIDES = [
  { src: "/hero/hero-shop.jpg", alt: "TMF beneficiary shopping for food at a local vendor's shop", pos: "center" },
  { src: "/hero/hero-bike.jpg", alt: "TMF beneficiary carrying a Text Me Food bag home on his motorcycle", pos: "center 35%" },
];

export const HeroSlideshow = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="relative rounded-[1.75rem] shadow-2xl w-full h-[420px] border-4 border-white overflow-hidden bg-emerald-50" data-testid="hero-slideshow">
      {SLIDES.map((s, k) => (
        <img key={s.src} src={s.src} alt={s.alt} style={{ objectPosition: s.pos }}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${k === i ? "opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute bottom-3 right-4 flex gap-1.5">
        {SLIDES.map((s, k) => (
          <button key={s.src} type="button" aria-label={`Show photo ${k + 1}`} data-testid={`hero-dot-${k}`} onClick={() => setI(k)}
            className={`h-2 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-6 bg-white" : "w-2 bg-white/60"}`} />
        ))}
      </div>
    </div>
  );
};
